export const GET_BLUEPRINTS_QUERY_KEY = 'getBlueprints';

export const GET_BLUEPRINT_TASKABLE_TYPES_QUERY_KEY = 'getBlueprintTaskableTypes';

export const BLUEPRINTS_PATH = '/blueprints';
